<script>
export default {
  name: 'LayoutOneBlock'
}
</script>

<template lang="pug" src="./template.pug"></template>
<style lang="scss" src="./style.scss" scoped></style>
